export const dropdownMenu = {
  profile: "账户",
  mobilePaidAccounts: "手机支付账户",
  movements: "交易记录",
  contact: "联系人",
  changePassword: "更改密码",
  inviteFriend: "邀请朋友",
  deposit: "存款",
  withdrawal: "提现",
  transfer: "转账",
  logout: "退出登录",
  points: "积分",
  level: "等级",
  language: "语言",
};
